module.exports = __webpack_public_path__ + "static/media/background.4ec988a9.jpg";